interface JourneyStepData {
    id: number;
    title: string;
    description: string;
    detail: string[];
}


const steps: JourneyStepData[] = [
    {
        id: 0,
        title: "Pracovní bankovní účet + BankID",
        description: "Založ si nový účet u jiné banky jen na brigádu a aktivuj si BankID.",
        detail: [
            "Otevři si účet u jiné banky, než kam ti chodí výplata — ideálně moderní banku bez poplatků (mBank, Raiffeisenbank).",
            "Přes tento účet budeš vkládat a vybírat peníze z kasín — oddělíš tím brigádu od osobních financí a ochráníš svou bonitu.",
            "V aplikaci banky si aktivuj BankID — bez něj se do většiny kasín nezaregistruješ.",
            "Tip: podívej se na bankovní bonusy v DigiBrigi, některé banky dávají odměnu za otevření účtu.",
        ],
    },
    {
        id: 1,
        title: "Pracovní e-mail na kasína",
        description: "Vytvoř si nový e-mail, který budeš používat výhradně pro registrace do kasín.",
        detail: [
            "Založ si nový e-mail (Gmail, Seznam, cokoliv) jen na brigádu.",
            "Registruj se s ním do všech kasín — marketingový spam ti pak nezahltí osobní schránku.",
            "Nepoužívej svůj běžný ani pracovní e-mail.",
        ],
    },
    {
        id: 2,
        title: "První bonus",
        description: "Otevři si bonus bez rizika nebo s nízkým rizikem a projdi kroky v jeho detailu.",
        detail: [
            "V sekci Bonusy vyber bonus označený „Bez rizika“ nebo „Nízké riziko“.",
            "Klikni na „Začít“ a otevři si detail bonusu.",
            "Postupuj přesně podle kroků v detailu — každý krok si odškrtni, jakmile ho splníš.",
            "Než začneš, můžeš si zapsat počáteční zůstatek u kasína, ať ti výdělek spočítáme automaticky.",
        ],
    },
    {
        id: 3,
        title: "Zapiš si první výdělek",
        description: "Po dokončení bonusu ho označ jako splněný a zapiš si dosažený výdělek.",
        detail: [
            "Až splníš všechny kroky bonusu, klikni na „Označit jako dokončené“.",
            "Vyskočí okno pro zapsání výdělku.",
            "Výdělek spočítej podle vzorce: současný zůstatek − počáteční zůstatek − vklady + výběry.",
            "Zápis je důležitý pro tvé přehledy i pro případné daňové přiznání.",
        ],
    },
    {
        id: 4,
        title: "Nastav si bankovní účet pro výplaty",
        description: "Přidej si bankovní účet v sekci Doporučení a nastav si vyplácení odměn.",
        detail: [
            "V sekci Doporučení najdeš svůj odkaz a přehled odměn.",
            "Přidej si číslo bankovního účtu, kam ti mají chodit peníze.",
            "Zapni si automatický výběr — odměny ti pak chodí samy, vždy do 7. dne měsíce.",
        ],
    },
    {
        id: 5,
        title: "Investuj výdělky",
        description: "Podívej se do investiční sekce a zvaž pasivní investování svých výdělků.",
        detail: [
            "Neutrať všechno — část výdělků nech pracovat.",
            "V investiční sekci najdeš inspiraci: DigiBrigi koláč a široce diverzifikovaný globální fond (VWCE).",
            "Vzdělávej se v pasivním investování a globálních ETF.",
        ],
    },
];


export default steps;